import { render, staticRenderFns } from "./spareGetList.vue?vue&type=template&id=2bdd912c&scoped=true"
import script from "./spareGetList.vue?vue&type=script&lang=js"
export * from "./spareGetList.vue?vue&type=script&lang=js"
import style0 from "./spareGetList.vue?vue&type=style&index=0&id=2bdd912c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd912c",
  null
  
)

export default component.exports